import { OnInit, OnDestroy, Component} from '@angular/core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../../services/NXI-Rest.service';
import { AWRContextUtils, AwrDomainContext, AWRContextService } from '@pershing/nxi-core';

declare let dojoApp: any;

@Component({
    selector: 'dojo-awr-time-period-picker',
    templateUrl: './awr-time-period-picker.component.html'
})
export class DojoAwrTimePeriodPickerComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    dataFromStorage: any ;
    goToTab: string;
    timePeriod: string;
    constructor(private awrContextService: AWRContextService, private nxiRestService: NxiRestService) {
    }

    ngOnInit() {
        this.subs = this.awrContextService.selectedAwrDomainContext$.subscribe((awrDomainContext: AwrDomainContext<any>) => {
            let contextValue = AWRContextUtils.getContextFromDomainValue(awrDomainContext);
            if (contextValue.timePeriod) {
                this.timePeriod = contextValue.timePeriod;
            }
            if (this.acctRef !== contextValue.accountNumber) {
                this.acctRef = contextValue.accountNumber;
                this.getAWRTimePeriodPicker();
            }
        });       
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyAwrTimePeriodPicker();
        }
    }
    renderDojoWidget(awrTimePeriodDojoParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderAwrTimePeriodPicker(awrTimePeriodDojoParams);
        }
    }

    getAWRTimePeriodPicker() {
        if (this.acctRef !== '') {
            this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'awrTimePeriodPicker').subscribe(
                resp => {
                    console.log('Retrived Portfolio AWR Timeperiod params : ', resp.response);
                    if (resp.response) {
                        if (this.timePeriod) {
                            resp.response.timePeriod = this.timePeriod;
                        }
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }
}
